import { numberFormat } from './intl-cache';

const whitespace = /\s/;
const allWhitespace = /\s/g;

const separatorCache = new Map<string, { decimal: string; group: string }>();

const localeSeparators = (locale: string) => {
  const cached = separatorCache.get(locale);
  if (cached) return cached;
  const parts = numberFormat(locale).formatToParts(1234567.5);
  const decimal = parts.find((part) => part.type === 'decimal')?.value ?? '.';
  const group = parts.find((part) => part.type === 'group')?.value ?? (decimal === ',' ? '.' : ',');
  const separators = { decimal, group };
  separatorCache.set(locale, separators);
  return separators;
};

const decimalSeparatorOf = (value: string, candidates: string[], decimal: string) => {
  const present = candidates.filter((char) => value.includes(char));
  if (present.length === 0) return null;
  if (present.length > 1) {
    return present.reduce((last, char) =>
      value.lastIndexOf(char) > value.lastIndexOf(last) ? char : last,
    );
  }
  const separator = present[0]!;
  const at = value.indexOf(separator);
  if (at !== value.lastIndexOf(separator)) return null;
  if (separator === decimal) return separator;
  return /^\d{3}$/.test(value.slice(at + 1)) ? null : separator;
};

export const parseDecimalInput = (raw: string, locale: string): number => {
  const cleaned = raw.replace(allWhitespace, '');
  if (cleaned === '') return Number.NaN;
  const { decimal, group } = localeSeparators(locale);
  const candidates = ['.', ',', decimal, group].filter(
    (char, index, all) => all.indexOf(char) === index && !whitespace.test(char),
  );
  const point = decimalSeparatorOf(cleaned, candidates, decimal);
  return Number(
    Array.from(cleaned)
      .map((char) => {
        if (!candidates.includes(char)) return char;
        return char === point ? '.' : '';
      })
      .join(''),
  );
};
